<template>
  <div style="padding: 0 10px">
    <el-alert :closable="false" style="text-align: left;" type="error">
      <div slot="title" style="font-size: 20px;color:red">一个批次部分移库到成品区时，请重新生成一个批次并贴在商品上</div>
    </el-alert>
    <ScanQuery ref="keepFocus" @onQuery="queryCall" ph="输入批次包编码" :batchPanel="true"
      :disabled="dataSource.length > 0 && !targetRegion">
      <span style="margin-left: 10px" v-if="totalAmount">当前绑定数量:{{ totalAmount || 0 }}</span>
      <div style="margin-left: auto;position: relative;padding-bottom: 10px;" slot="customize">
        <el-select :value="targetRegion" placeholder="请选择移库库区" style="width: 200px;margin-right: 10px;"
          @change="regionChange($event)" :disabled="dataSource.length > 0 && !!targetRegion">
          <el-option v-for="item in regionList" :key="item.regionCode" :label="item.regionName"
            :disabled="isSpecialPkg(item)" :value="item.regionCode">
          </el-option>
        </el-select>
        <span class="tips" v-if="dataSource.length > 0 && !targetRegion">请选择移库库区</span>
        <el-button type="primary" :disabled="!dataSource.length || !targetRegion" @click="submitTransfer"> 一键移库
        </el-button>
      </div>
    </ScanQuery>
    <WmsTable :is-pagination="false" :columns="columns" :dataSource="dataSource" isExpanded_hidden :keepExpended="true"
      rowKey="id" ref="wmsTable" :hasHeader="false">
      <ImgView slot="productImgAction" slot-scope="{text}" :src="text"></ImgView>
      <template slot="singleProductFlag" slot-scope="{text, record, index}">
        <span
          :class="record.systemSource == 1 && (record.singleProductFlag == 1 || record.singleProductFlag == true) && record.processingStatus == 2 ? 'prominent' : ''">{{
            record.amount == 1 ? "单件" : "多件" }}</span>
      </template>
      <div slot="moveNum" slot-scope="{text, record}">
        <el-input-number :disabled="record.pkgType != 1" :key="record._timeKey" :controls="false" style="width: 100px;"
          controls-position="right" :min="1" :max="record.amount" @blur="moveBlur($event, record)"
          :value="record.amount">
        </el-input-number>
        <span>件</span>
      </div>
      <div class="flex" slot="pkgCode" slot-scope="{text, record }">
        <span>{{ text }}</span>
        <el-tag size="small" v-if="record.spiltType == 1" type="danger">拆</el-tag>
        <el-tag size="small" v-if="record.crossDockingFlag == 1" type="danger">可越库</el-tag>
      </div>
      <div slot="fromRegionAction" slot-scope="{text}">
        <span>{{ regionMap[text] }}</span>
      </div>
      <div slot="amount" slot-scope="{text}">
        <span :style="`${text > 1 ? 'color:red;font-weight:600' : ''};`">{{ text }}</span>
      </div>
      <div slot="productName" slot-scope="{text,record}">
        <a target='_blank' :href="record.productLink" v-if="record.productLink">{{ text }}</a>
        <span v-else>{{ text }}</span>
      </div>
      <div slot="specialCheckRequirement" slot-scope="{text,record}">
        <ImgView :src="record.specialCheckRequirementImg" v-if="record.specialCheckRequirementImg"></ImgView>
        {{ text || '-' }}
      </div>
      <!-- <div slot="targetRegionAction" slot-scope="text, record, index">
        <el-select v-model="record.targetRegion" placeholder="请选择" style="width: 120px"
          @change="targetRegionSel($event, index, record)">
          <el-option v-for="item in regionList" :key="item.regionCode" :label="item.regionName" :value="item.regionCode">
          </el-option>
        </el-select>
      </div> -->
      <div style="width: 100px" slot="action" slot-scope="{text, record, index}">
        <el-link type="primary" :underline="false" @click="cancelTransfer(record)">取消</el-link>
        <el-divider direction="vertical"></el-divider>
        <el-link type="primary" :underline="false" @click="printTransfer(record)">打印</el-link>
      </div>

      <template slot="expandedRender" slot-scope="{ text, record, index }">
        <el-card shadow="never">
          <el-collapse :value="1" @change="collapseChange">
            <el-collapse-item title="商品附加项：" :name="1">
              <div class="additional__div--items" v-if="record.additionList">
                附加项名称:{{ record.additionList.additionName }}<br />
              </div>
            </el-collapse-item>
            <el-collapse-item title="异常处理：" :name="2">
              <Content :abnormal-type="abnormalPkgSplit" abnormal="Purchase" btnTitle="登记库内异常"
                @submitAbnormal="purchaseCall($event, record, index)" :ref="'check_AbnormalSubmit_Purchase' + index" />
            </el-collapse-item>
          </el-collapse>
        </el-card>
      </template>
    </WmsTable>
    <MovePartDialog @cancel="refreshCancel" @ok="refreshTable" ref="movePart" />
    <CancelPartDialog @ok="cancelFilter" ref="cancelPart" />
  </div>
</template>

<script>
import TransferAbnormal from "./components/TransferAbnormal";
import ImgView from "@/components/ImgView";
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import Content from "./components/Abnormal/Content";
import ImgPreviews from '@/components/ImgPreviews';
import { audioPay } from "@/utils/tools";
import { columns, testDataSourceMap } from "@/views/inHouse/createTransferData";
import { createTransferMonde, getPkgInfoSingle, getOrderAdditionApi, queryPkgTransferList, transferGetTransferSpiltPkgs } from "@/apis/inHouse";
import { setTimeout } from "timers";
import { getRegionList } from "@/apis/configure";
import { abnormalPkgSplit, abnormalClient } from "@/types";
import { pkgSplit, createInnerException } from "@/apis/abnormal";
import { getAdditionalItemsInfo } from "@/apis/checking";
import MovePartDialog from "./transferDialog/movePart.vue"
import CancelPartDialog from "./transferDialog/cancelPart.vue"

import { Table, Alert } from "ant-design-vue";
export default {
  title: "发起库区移动",
  name: "CreateTransfer",
  components: {
    TransferAbnormal,
    ScanQuery,
    WmsTable,
    [Table.name]: Table,
    [Alert.name]: Alert,
    Content,
    ImgPreviews,
    CancelPartDialog,
    MovePartDialog,
    ImgView
  },
  data() {
    return {
      abnormalPkgSplit,
      targetRegionRecord: "", // 记录上一次选择库区的记录
      query: {
        code: "",
      },
      columns: columns,
      dataSource: [],
      regionList: [],
      regionMap: {},
      isExpanded: true,
      targetRegion: '',
      onCopy: false,
      partSureShow: false,// 部分移库确认弹窗
      moveData: {},
    };
  },
  created() {
  },
  computed: {
    specialFlag(){
      return this.dataSource.some((v)=>v.actualRegionName.includes('初检区') && v.specialFlag)
    },
    totalAmount: function () {
      let num = 0
      this.dataSource.forEach(item => {
        num += item.amount
      })
      return num
    }
  },
  methods: {
    // 移库失去焦点事件
    moveBlur(e, record) {
      const value = e.target.value;
      // 空、0 情况
      if (!value) {
        e.target.value = record.amount
        return
      }
      if (value != record.amount) {
        this.partSureShow = true
        console.log(record);
        record.moveNum = value;
        this.$refs.movePart.showMovePart(new Array(record))
      }
    },
    // 打印外置
    printTransfer(data) {
      this.$wmsPrint.print().templatePrintByPkg([{ ...data }])
    },
    refreshCancel(e) {
      const index = this.dataSource.findIndex(i => i.pkgCode == e[0].pkgCode)
      this.dataSource.splice(index, 1, { ...e[0], _timeKey: new Date().getTime() })
      this.$forceUpdate()
      this.$nextTick(() => {
        console.log(this.dataSource);
      })
    },
    // 移库后的部分数据操作
    async refreshTable(res) {
      const index = this.dataSource.findIndex(v => v.pkgCode == res.originData)
      this.dataSource.splice(index, 1)
      this.getDataSource(res.pkgCode)
    },
    queryCall: function (payload) {
      this.query.code = payload.code;
      if (this.query.code) {
        let pkgList = this.query.code.split(',')
        pkgList.length > 1 ? this.batchDataSource() : this.getDataSource();
      }
    },
    areaRecordHandler: function (val) {
      this.targetRegionRecord = val;
    },
    regionChange($e) {
      if (this.dataSource.length) {
        if (this.dataSource.length == 1 && !this.targetRegionSel(this.dataSource[0], $e)) {
          return
        }
        if (this.dataSource.length > 1) {
          let targetData = this.dataSource.filter(v => this.targetRegionSel(v, $e))
          if (targetData.length != this.dataSource.length) {
            this.$confirm(`部分批次包不能移库到该库区，已从页面上取消这部分批次包`, "部分批次包无法选择该库区", {
              confirmButtonText: "我知道了",
              type: "error",
              showCancelButton: false,
              closeOnPressEscape: false,
              closeOnClickModal: false
            }).then(() => {
            });
          }
          this.dataSource = targetData
        }
      }
      this.targetRegion = $e
    },
    targetRegionSel(data, targetRegion = this.targetRegion) {
      let that = this
      //regionStatus: bindStatus 0-初检，1-复检，3-质检，4-成品，5-异常，6-次品
      //pkgType 1-正品, 2-次品, 3-异常, 4-异常上报采购
      //productType 1-普通商品, 2-OEM商品, 3-组合商品
      //combinationProductItemFlag  是否组合子商品 1-是
      //status 1-初检，2-复检，3-精检，4-成品，5-异常，6-次品
      let regionStatus = targetRegion && that.regionList.filter(item => item.regionCode == targetRegion)[0].bindStatus
      regionStatus = String(regionStatus)
      let { status, combinationProductItemFlag, pkgType } = data

      // let needsCheck = data.hasAddtion || data.specialCheckRequirementImg || data.specialCheckRequirement
      // 如果没有包装尺寸测量数据（部分用户），需要先去质检区，不能直接移库成品区
      if(data.packageSizeMeasure && regionStatus == 4) {
        this.$message.warning('sku从未有过包装尺寸测量记录，请移至质检区质检')
        return ''
      }
      // 去掉特殊质检要求
      let needsCheck = data.hasAddtion

      console.log(regionStatus, status, combinationProductItemFlag, pkgType, needsCheck)
      const crossDockingFlag = data.crossDockingFlag
      if (pkgType == 2) {
        if (regionStatus && regionStatus != 6) {
          this.$message.warning('次品请移库至次品区')
          resetSelValue()
          return ''
        }
      } else if (pkgType == 3 || pkgType == 4) {
        if (regionStatus && regionStatus != 5) {
          this.$message.warning('异常批次请移库至异常区')
          resetSelValue()
          return ''
        }
      } else {
        if (this.dataSource.some(v => v.crossDockingFlag != crossDockingFlag)) {
          this.$confirm(`页面已存在【${crossDockingFlag ? '不可越库' : '可越库'}】批次包，请继续扫描【${crossDockingFlag ? '不可越库' : '可越库'}】批次包或直接发起移库`, "不可越库与可越库批次包不能同时移库", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          })
          resetSelValue()
          return false
        }
        if (pkgType == 1 && regionStatus == 6) {
          resetSelValue()
          this.$message.warning('正品无法移库至次品区')
          return ''
        }
        if (status == 3 && regionStatus == 3) {
          this.$message.warning('质检区的批次包不能移库至质检区')
          resetSelValue()
          return ''
        }
        if (status == 1 && combinationProductItemFlag != 1) {
          if (regionStatus && regionStatus == 4 && needsCheck) {
            resetSelValue()
            // this.$message.warning('存在质检附件项或特殊质检要求，请移至质检区质检')
            this.$message.warning('存在质检附件项，请移至质检区质检')
            return ''
          }
        } else if (status == 1 && combinationProductItemFlag == 1) {
          if (regionStatus && (regionStatus == 4 || regionStatus == 6)) {
            resetSelValue()
            this.$message.warning('组合商品请移至质检区质检上架')
            return ''
          }
        } else if (status == 3 && combinationProductItemFlag != 1) {
          if (regionStatus && (regionStatus == 0 || regionStatus == 6)) {
            resetSelValue()
            this.$message.warning('成品请移至成品区上架')
            return ''
          }
        } else if (status == 3 && combinationProductItemFlag == 1) {
          if (regionStatus && (regionStatus == 0 || regionStatus == 4 || regionStatus == 6)) {
            resetSelValue()
            this.$message.warning('组合商品请在质检区上架')
            return ''
          }
        }
      }
      return true

      // that.targetRegionRecord = val
      // return that.targetRegionRecord

      function resetSelValue() {
        // if(type != 'batch'){
        //   _data[index].targetRegion = ''
        //   that.targetRegionRecord = ''
        //   that.dataSource = _data
        // }
      }

    },
    isSpecialPkg(region,flag){
      if(!region)return
      if(!flag && !this.specialFlag)return
      if(region.bindStatus===4)return true
    },
    getDataSource: function (pkgCode = this.query.code.trim()) {
      const that = this;
      const isHas = that.dataSource.some((item) => item.pkgCode === pkgCode);
      if (isHas) {
        that.$message.warning("批次包已存在");
        return;
      }
      getPkgInfoSingle({ pkgCode }).then(({ code, data }) => {
        if (code === 0) {
          if (data.actualRegionName.includes('初检区') && data.specialFlag) {
            const region = this.regionList.find(v => v.regionCode === this.targetRegion)
            const valid = this.isSpecialPkg(region,true)
            if (valid) {
              return  that.$message.error("该批次带有特殊质检要求，请先移库至质检区");
            }
          } else {
            this.specialFlag = false
          }
          audioPay(`${data.amount}件`);
          data.additionalList = data.additionalList || []
          let addition = {
            additionName: '',
            ingredientsName: ''
          }
          data.additionalList.forEach((item, index) => {
            addition.additionName += item.additionName + ','
            addition.ingredientsName += item.ingredientsName + ','
          })
          data.hasAddtion = !!data.additionalList.length
          data.additionList = addition
          if (!that.targetRegionSel(data)) {
            return false
          }
          that.dataSource = [
            {
              ...data
            },
            ...that.dataSource,
          ];
          that.dataSource.forEach(item => {
            item.moveNum = item.amount
          })
          // data.targetRegion = that.targetRegionSel(that.targetRegionRecord, 0, data),
          //   that.$set(that.dataSource, 0, data)
          that.$nextTick(() => {
            that.$refs.wmsTable.expandedOneRows(true, data);
          })
        }
      });
    },
    batchDataSource: function () {
      const that = this;
      let pkgList = that.query.code.split(',')
      const targetPkg = pkgList.filter(item => that.dataSource.every(d => d.pkgCode != item))
      queryPkgTransferList({ pkgCodeList: targetPkg }).then(({ code, data }) => {
        let tips = 0
        let couldTransferList = []
        if (data.filter(v => v.pkgType == 1).some(v => v.crossDockingFlag != data[0].crossDockingFlag)) {
          this.$confirm(`请将不可越库与可越库批次包分开创建移库单`, "不可越库与可越库批次包不能同时移库", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          })
          return false
        }
        if (this.dataSource.some(v => v.crossDockingFlag != data[0].crossDockingFlag)) {
          this.$confirm(`页面已存在【${data[0].crossDockingFlag ? '不可越库' : '可越库'}】批次包，请继续扫描【${data[0].crossDockingFlag ? '不可越库' : '可越库'}】批次包或直接发起移库`, "不可越库与可越库批次包不能同时移库", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          })
          return false
        }
        data.forEach(pkg => {
          pkg.additionalList = pkg.additionalList || []
          let addition = {
            additionName: '',
            ingredientsName: ''
          }
          pkg.additionalList.forEach((item, index) => {
            addition.additionName += item.additionName + ','
            addition.ingredientsName += item.ingredientsName + ','
          })
          pkg.hasAddtion = !!pkg.additionalList.length
          pkg.additionList = addition
          if (!that.targetRegionSel(pkg)) {
            tips++
            return false
          }
          couldTransferList.push(pkg)
          // pkg.targetRegion = that.targetRegionSel(that.targetRegionRecord, 0, pkg,'batch')
        })
        if (tips) {
          this.$confirm(`部分批次包不能移库到该库区，页面上将不会显示这部分批次包`, "部分批次包无法选择该库区", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
          });
        }
        that.dataSource = [
          ...couldTransferList,
          ...that.dataSource,
        ];
        that.$nextTick(() => {
          data.forEach(pkg => {
            that.$refs.wmsTable.expandedOneRows(true, pkg);
          })
        })
      })
    },
    submitTransfer: function (payload) {
      const that = this;
      const params = this.dataSource.map((item) => {
        return {
          ...item,
          targetRegion: that.targetRegion,
          sourceRegion: item.regionCode,
          sourceName: that.regionMap[item.regionCode],
          targetName: that.regionMap[that.targetRegion],
        };
      })
      createTransferMonde(params).then(({ code, data, msg }) => {
        if (code === 0) {
          that.$message.success("成功");
          that.dataSource = [];
          that.targetRegion = ''
        } else if (code == '26010019') {
          this.$confirm(msg, "部分批次包无法移库", {
            confirmButtonText: "我知道了",
            type: "error",
            showCancelButton: false,
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
          });
        }
      });
      // console.log(params);
      // TODO 单个发起移库
    },
    submitTransferAbnormal: function (payload) {
      console.log(payload);
    },
    cancelFilter(payload) {
      this.dataSource = this.dataSource.filter((item) => item.pkgCode !== payload.pkgCode);
      this.$message.warning("已取消");
    },
    async cancelTransfer(payload) {
      const res = await transferGetTransferSpiltPkgs({ pkgCode: payload.pkgCode })
      if (res.code === 0 && res.data?.length) {
        this.$refs.cancelPart.showCancelPart({ list: res.data, originData: payload })
      } else {
        this.cancelFilter(payload)
      }
    },
    regionPage() {
      getRegionList().then(({ code, data }) => {
        if (code === 0) {
          this.regionList = data;
          let _map = {};
          data.forEach((item) => {
            _map[item.regionCode] = item.regionName;
          });
          this.regionMap = _map;
        }
      });
    },
    isRegionType3(regionCode) {
      return this.regionList.filter(item => item.bindStatus == 3).some(item => item.regionCode == regionCode)
    },
    purchaseCall: function (payload, record, index) {
      // if (record.combinationProductItemFlag && this.isRegionType3(record.regionCode)) {
      //   this.$message.warning("组合子商品移库质检区后,不能新增异常")
      //   return
      // }
      let childen = this.$refs['check_AbnormalSubmit_Purchase' + index];
      if (childen.radio != 1 && childen.radio != 0) {
        this.$message.error("请选择异常类型");
        return false;
      }
      const params = {
        abnormalType: childen.radio,
        // picRelation: childen.qrCode,
        pkgCode: record.pkgCode,
        abnormalAmount: childen.abnormalAmount,
        remark: childen.textarea,
        picRelation: payload.qrCode,
      };
      if (params.abnormalAmount == 0 || !params.abnormalAmount) {
        this.$message.error("数量必须大于0");
        return;
      }
      console.log(record)
      if (params.abnormalAmount > record.amount) {
        this.$message.error("超过商品数量");
        return;
      }
      createInnerException(params).then(({ code }) => {
        if (code === 0) {
          this.$message.success("成功");
          if (childen.radio === 0) {
            let data = [...this.dataSource]
            data[index].amount -= params.abnormalAmount
            this.dataSource = data
          }
          this.$emit("DoStockIn");
        }
      });
    },
    collapseChange() {
      console.log('resetExpandHeight')
      let that = this
      setTimeout(() => {
        that.$refs.wmsTable.resetExpandHeight()
      }, 300)
    }
  },
  mounted() {
    setTimeout(() => {
      this.isExpanded = false;
    }, 1000);
    this.regionPage();
    // document.addEventListener('oncopy', function(e) {
    //   console.log('copy',e)
    //   this.onCopy = true
    // });
    var focusFunc = setInterval(() => {
      if (!!window.getSelection().toString()) {
        return
      }
      if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
        return
      }
      if (this.$refs.keepFocus) {
        this.$refs.keepFocus.focusIpt()
      }
    }, 300);
  },
  beforeUnmount() {
    console.log('beforeUnmount')
    clearInterval(focusFunc)
  }
};
</script>

<style scoped>
.additional__div--items {
  min-height: 40px;
  background: #f3f3f3;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 10px;
}

.prominent {
  color: red;
  font-size: large;
  font-weight: 600;
}

.tips {
  position: absolute;
  top: 30px;
  left: 0px;
  color: red
}

:v-deep {
  .el-input-number__decrease {
    display: none
  }

  .el-input-number__increase {
    display: none;
  }
}
</style>
